export default __webpack_public_path__ + "static/media/scale@3x.f3ab6c60.png";